var Reverb = window.Reverb || {};

Reverb.PaypalProfile = (function () {
  var verificationSelector = 'pending-paypal-verification';
  var verificationDataSelector = '[data-' + verificationSelector + ']';

  var verificationPendingSelector = '[data-verification-pending]';
  var verificationSuccessSelector = '[data-verification-success]';
  var verificationFailureSelector = '[data-verification-failure]';

  var verificationFormSelector = '[data-bind = \'paypal-verification-form\']';
  var verificationSubmitSelector = '[data-bind = \'paypal-verification-submit\']';
  var closeVerificationFormSelector = '[data-bind = \'close-paypal-form\']';

  var verificationSpinnerSelector = '[data-bind="paypal-verification-spinner"]';
  var verificationSuccessMessage = '[data-bind="paypal-verification-success"]';
  var verificationFailureMessage = '[data-bind="paypal-verification-failure"]';

  var timesChecked = 0;

  function checkVerificationStatus() {
    var elementsNeedingPaypalVerification = $(verificationDataSelector);

    if (elementsNeedingPaypalVerification.length > 0) {
      getAndCheckStatusRecursively();
    }
  }

  function bindVerificationFormSubmit() {
    $(document).on('submit', verificationFormSelector, function (e) {
      e.preventDefault();

      $(verificationSpinnerSelector).show();
      $(verificationFailureMessage).hide();
      verifyPaypalProfile();
    });
  }

  function verifyPaypalProfile() {
    var form = $(verificationFormSelector).children(form);
    var action = form.attr('action');

    $.post(action, form.serialize()).done(function (data) {
      verificationSuccess();
    }).fail(function (xhr) {
      verificationFailed();
    }).always(function () {
      $(verificationSpinnerSelector).hide();
    });
  }

  function verificationSuccess() {
    $(verificationSuccessMessage).show();
    $(closeVerificationFormSelector).show();
    $(verificationSubmitSelector).hide();
  }

  function verificationFailed() {
    $(verificationFailureMessage).show();
    $('[data-bind="paypal-verification-failure"]').show();
    $(verificationSubmitSelector).removeClass('btn-disabled');
    $(verificationSubmitSelector).removeAttr('disabled');
  }

  function getAndCheckStatusRecursively() {
    if (timesChecked < 30) {
      setTimeout(getAndCheckStatus, 1000);
      timesChecked++;
    }
  }

  function queryVerificationStatus(callback) {
    var url = $(verificationDataSelector).data(verificationSelector);

    $.get(url).done(function (data) {
      callback(data.status);
    });
  }

  function getAndCheckStatus() {
    queryVerificationStatus(function (status) {
      if (status === 'verified') {
        $(verificationPendingSelector).hide();
        $(verificationSuccessSelector).show();
      } else if (status === 'verification_failed') {
        $(verificationPendingSelector).hide();
        $(verificationFailureSelector).show();
      } else if (status === 'pending_verification') {
        getAndCheckStatusRecursively();
      }
    });
  }

  function init() {
    checkVerificationStatus();
    bindVerificationFormSubmit();
  }

  return {
    init: init
  };
})();

$(Reverb.PaypalProfile.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/paypal_profile.js